import {epos2Axios} from "@/interceptors/axios";

class ReportService {
    async searchLockerUsage(serverOptions) {
        try {
            let config = {
                params: {
                    page: serverOptions.page,
                    limit: serverOptions.rowsPerPage,
                    order_by: serverOptions.sortBy,
                    order_direction: serverOptions.sortType,
                    filters: serverOptions.filters,
                },
            }

            config.params.start_date = serverOptions.start_date;
            config.params.end_date = serverOptions.end_date;
            config.params.locker_type = serverOptions.locker_type;

            const response = await epos2Axios.get('/api/reports/locker-usage', config);

            return {
                serverCurrentPageItems: response.data.data.lockers,
                serverTotalItemsLength: response.data.data.pagination.found_rows,
            };
        } catch (error) {
            console.error('Error fetching data:', error);
            return {
                serverCurrentPageItems: [],
                serverTotalItemsLength: 0,
            };
        }
    }

    async downloadLockerUsage(serverOptions) {
        try {
            let  params = {
                order_by: serverOptions.sortBy,
                order_direction: serverOptions.sortType,
                filters: serverOptions.filters,
                export: 'csv',
            }
            if(serverOptions.start_date !== ""){
                params.start_date = serverOptions.start_date;
            }
            if(serverOptions.end_date !== ""){
                params.end_date = serverOptions.end_date;
            }
            if(serverOptions.locker_type !== ""){
                params.locker_type = serverOptions.locker_type;
            }
            const response = await epos2Axios.get('/api/reports/locker-usage', {
                params,
                responseType: 'blob', // Set the response type to 'blob' for binary data
            });

            const blob = new Blob([response.data], { type: 'application/zip' });

            // We create a temporary link that contains the zip file
            // we then click it programmatically to download the file
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'lockers_usage.zip';
            document.body.appendChild(link);
            link.click();

            // Remove the link from the document
            document.body.removeChild(link);
        } catch (error) {
            console.error('Error downloading file:', error);
        }
    }
}

export default new ReportService();